
const matomoTracking = {

    methods: {
        trackEvent(kategorie, aktion){
            if(window._paq != undefined)
                window._paq.push(['trackEvent', kategorie, aktion])
        },
        trackCookieConsentGiven() {
            if(window._paq != undefined)
                window._paq.push(['rememberCookieConsentGiven'])
        },
        trackForgetCookieConsent(){
            if(window._paq != undefined)
                window._paq.push([ 'forgetCookieConsentGiven' ]);
        },
        setCustomUrl(url){
            if(window._paq != undefined)
                window._paq.push(['setCustomUrl', url])
        },
        trackPageView(){
            if(window._paq != undefined)
                window._paq.push(['trackPageView'])
        },
        trackGoal(goal){
            if(window._paq != undefined)
                window._paq.push(['trackGoal', goal])
        },
        setUserId(userId){
            if(window._paq != undefined)
                window._paq.push(['setUserId', userId])
        }
    }
}

export default matomoTracking;